import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { COLORS } from "Constants";
import xrange from "highcharts/modules/xrange";
import noData from "highcharts/modules/no-data-to-display";
import { THEME_DEFAULT, THEME_LIGHT } from "store/userMeta";
import { useSelector } from "react-redux";
import { State } from "store";

// TODO: This may need to move.  Remains to be seen if xrange can be part of baseChart or not....
xrange(Highcharts);
noData(Highcharts);

Highcharts.setOptions({
  lang: {
    thousandsSep: ","
  }
});

interface BaseChartProps {
  options: Highcharts.Options;
  colors: string[];
  plotOptions: object;
}

const BaseChart: React.FC<BaseChartProps> = ({
  options,
  colors,
  plotOptions
}) => {
  const theme = useSelector((state: State) => {
    return state.userMeta?.theme ?? THEME_DEFAULT;
  });

  let backgroundColor = COLORS.CARD_GREY;
  let textColor = COLORS.WHITE;
  let titleColor = COLORS.WHITE;
  let chartColor = "#4D545C"; // recommended dark-mode gridLine color by UX

  if (THEME_LIGHT === theme) {
    backgroundColor = COLORS.WHITE;
    textColor = "#666666"; // default axis labels text color in Highcharts
    titleColor = "black";
    chartColor = "#e6e6e6"; // default gridLine color in Highcharts
  }

  return (
    <HighchartsReact
      highcharts={Highcharts}
      options={{
        ...options,
        colors,
        chart: {
          spacingBottom: 20,
          spacingTop: 10,
          spacingLeft: 10,
          spacingRight: 10,
          marginTop: 45,
          backgroundColor,
          style: {
            fontFamily: "Lato, sans-serif"
          },
          ...options.chart
        },
        title: {
          align: "left",
          margin: 32,
          style: {
            color: titleColor,
            fontWeight: "bold"
          },
          ...options.title
        },
        lang: {
          noData: "No charting data available"
        },
        noData: {
          style: {
            fontFamily: "Lato",
            color: COLORS.WHITE
          }
        },
        legend: {
          itemStyle: {
            color: titleColor,
            opacity: 0.7
          },
          itemHoverStyle: {
            color: titleColor,
            opacity: 1
          },
          ...options.legend
        },
        xAxis: {
          labels: {
            style: {
              color: textColor
            }
          },
          ...options.xAxis
        },
        yAxis: {
          labels: {
            style: {
              color: textColor
            }
          },
          gridLineColor: chartColor,
          ...options.yAxis
        },
        credits: { enabled: false },
        time: {
          useUTC: true
        },
        tooltip: {
          valueDecimals: 1,
          ...options.tooltip
        },
        plotOptions: {
          ...plotOptions
        }
      }}
    />
  );
};

export default BaseChart;
